import React from "react";
import { useDispatch, useSelector } from "react-redux";
import EmployeesList from 'src/pages/admin/companies/employees/employee-list';
import { ApplicationState } from "../../../../stores/reducers";
import { refreshTableEmployeeToggle } from "../../../../stores/actions/Employee";


export const WrapperEmployeeTable = (props: any) => {
    const dispatch = useDispatch();
    const handleRefreshTable = (value: boolean) => {
        dispatch(refreshTableEmployeeToggle(value));
    };
    const isRefreshTable = useSelector((state: ApplicationState) => state.employee.refreshTablet);

    return <EmployeesList
             handleResetTableSuccess={handleRefreshTable}
            isRefreshTable={isRefreshTable}
            {...props}
         />
}